import "./Events.css";
import { tinaField, useTina } from "tinacms/dist/react";
import eventsPageContent from "../../../content/pages/events.json";
import { PageDocument } from "../../../tina/__generated__/types";
import { PageSeo } from "../../navigation/PageSeo";

const initialPageData = { page: eventsPageContent };
const pageVariables = { relativePath: "events.json" };

export const Events = () => {
  const { data } = useTina({ query: PageDocument, variables: pageVariables, data: initialPageData });
  const page = data.page;
  const events = page.events ?? [];

  return (
    <main className="events-page">
      <PageSeo pathname="/events" seo={page.seo} />
      <header className="events-hero page-hero-dots">
        <p className="events-eyebrow" data-tina-field={tinaField(page, "eyebrow")}>
          {page.eyebrow}
        </p>
        <h1 data-tina-field={tinaField(page, "heading")}>{page.heading}</h1>
        <p data-tina-field={tinaField(page, "description")}>{page.description}</p>
      </header>

      <section className="events-list" aria-label="Upcoming events">
        {events.map((event, index) => (
          <article className="event-card" key={`${event.title}-${index}`} data-tina-field={tinaField(event)}>
            <div className="event-date" aria-label={`${event.month} ${event.year}`}>
              <span data-tina-field={tinaField(event, "month")}>{event.month}</span>
              <strong data-tina-field={tinaField(event, "year")}>{event.year}</strong>
              <b data-tina-field={tinaField(event, "dates")}>{event.dates}</b>
            </div>
            <div className="event-details">
              <p className="event-type" data-tina-field={tinaField(page, "eventType")}>
                {page.eventType}
              </p>
              <h2 data-tina-field={tinaField(event, "title")}>{event.title}</h2>
              <p className="event-venue" data-tina-field={tinaField(event, "venue")}>
                {event.venue}
              </p>
              <p className="event-location" data-tina-field={tinaField(event, "location")}>
                {event.location}
              </p>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
};

export default Events;
